import { Dialog } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/outline';
import React from 'react';
import { UserType } from '../types/user';

interface MemberFoundProps {
  user: UserType | null;
}

const MemberFound: React.FC<MemberFoundProps> = ({ user }) => {
  return (
    <div>
      <div className="ceas-mx-auto ceas-flex ceas-items-center ceas-justify-center ceas-h-12 ceas-w-12 ceas-rounded-full ceas-bg-green-100">
        <CheckIcon className="ceas-h-6 ceas-w-6 ceas-text-green-600" aria-hidden="true" />
      </div>
      <div className="ceas-mt-3 ceas-text-center sm:ceas-mt-5">
        <Dialog.Title
          as="h3"
          className="ceas-text-lg ceas-leading-6 ceas-font-medium ceas-text-gray-900"
        >
          Member Found.
        </Dialog.Title>
        <div className="ceas-mt-2">
          {user?.avatar_url && (
            <div className="ceas-mx-auto ceas-block ceas-h-40 ceas-w-40 ceas-rounded-full xl:ceas-w-50 xl:ceas-h-50 ceas-overflow-hidden">
              <img
                className="ceas-object-cover ceas-h-40"
                src={user?.avatar_url}
                alt="Member avatar"
              />
            </div>
          )}
          <p className="ceas-text-sm ceas-text-gray-500">
            {user?.name} ({user?.user_level})
          </p>
        </div>
      </div>
    </div>
  );
};

export default MemberFound;
